<ng-content></ng-content>
<ng-container *ngIf="bindingFormControl">
  <ng-container *ngIf="showValidationMessage()">
    <ng-container *ngFor="let key of errorKeys">
      <small *ngIf="getMsgByKey(key, validationMsgMap)" class="p-error">
        {{  this.bindingFormControl?.displayName | replaceNullWith : '' | translate }}
        {{ processMsg(getMsgByKey(key, validationMsgMap) | translate) }}
      </small>
    </ng-container>
    <ng-container *ngIf="messagesTemplate">
      <ng-container
        *ngTemplateOutlet="messagesTemplate; context: { $implicit: errorKeys }"
      >
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
